import React from 'react';
import { classes } from './ErrorNotification.st.css';
import { SectionNotification } from 'wix-ui-tpa';
import Error from 'wix-ui-icons-common/on-stage/Error';

export interface ErrorNotificationProps {
  errorText?: string;
}

const ErrorNotification: React.FC<ErrorNotificationProps> = ({ errorText }) => {
  return (
    <>
      {errorText ? (
        <SectionNotification
          type="error"
          className={classes.root}
          data-hook="error-notification"
        >
          <SectionNotification.Icon icon={<Error />} />
          <SectionNotification.Text className={classes.text}>
            {errorText}
          </SectionNotification.Text>
        </SectionNotification>
      ) : null}
    </>
  );
};

export default ErrorNotification;
